export default {
    manage_deleteWorkOrderStatus_title: "Eliminar Estado de Orden de Trabajo",
    manage_deleteWorkOrderStatuses_title: "Eliminar Estados de Orden de Trabajo",
    manage_deleteWorkOrderStatuses_description: "¿Está seguro de que desea eliminar estos estados de orden de trabajo?",
    manage_deleteWorkOrderStatus_description: "¿Está seguro de que desea eliminar este estado de orden de trabajo?",
    manage_deleteWorkOrderStatus_successMessage: "Estado de orden de trabajo eliminado",
    manage_deleteWorkOrderStatuses_successMessage: "Estados de orden de trabajo eliminados",
}